// import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/index.css";
import { ShellThemeProvider } from "@sede-enterprise/shell-ds-react-framework";
import { Provider } from "react-redux";
import { store } from "./store/index.ts";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { AuthProvider, type TAuthConfig } from "react-oauth2-code-pkce";
import App from "./App.tsx";
import "./i18n";
import {
  getSessionConfig,
  clearStaleLoginInProgress,
} from "./utils/sessionManager.ts";
import { StrictMode } from "react";

// Clear any stale `loginInProgress` flag left by an aborted/interrupted OAuth
// redirect before the AuthProvider mounts. Prevents the false
// "Expected to find a '?code=' parameter in the URL by now" error on page load.
clearStaleLoginInProgress();

const sessionConfig = getSessionConfig();

const authConfig: TAuthConfig = {
  clientId: import.meta.env.VITE_AUTH_CLIENT_ID,
  authorizationEndpoint: import.meta.env.VITE_AUTH_AUTHORIZATION_ENDPOINT,
  tokenEndpoint: import.meta.env.VITE_AUTH_TOKEN_ENDPOINT,
  redirectUri: import.meta.env.VITE_AUTH_REDIRECT_URI,
  scope: import.meta.env.VITE_AUTH_SCOPE,

  // Use sessionStorage for tab-specific sessions (no cross-tab synchronization)
  storage: "session",

  // Clear URL parameters after OAuth callback
  clearURL: true,

  // Disable automatic login - let our App component handle when to trigger login
  autoLogin: false,

  // Environment-aware token expiry times
  tokenExpiresIn: sessionConfig.accessTokenExpiry,
  refreshTokenExpiresIn: sessionConfig.refreshTokenExpiry,
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary fallback={<div>Error in Router</div>}>
      <Provider store={store}>
        <ShellThemeProvider theme="light">
          <AuthProvider authConfig={authConfig}>
            <App />
          </AuthProvider>
        </ShellThemeProvider>
      </Provider>
    </ErrorBoundary>
  </StrictMode>,
);
